import React from 'react';
import { Card, CardContent, Separator, Grid, GridColumn, LargeSearch, TextField, Image, Text, Container, Heading, Button } from 'telia-front-react';
import ErrorUtil from '../../../util/ErrorUtil';
const sendErrorToTeliaRum = (monitoringDisabled) => {
    if (monitoringDisabled) {
        return;
    }
    const error = new Error('404 page not found');
    error.stack = window.location.pathname;
    ErrorUtil.pushErrorToTeliaRumAndLog(error);
};
const handleMissingTranslation = (key, monitoringDisabled) => {
    if (monitoringDisabled) {
        return;
    }
    const error = new Error('Translation missing');
    error.stack = `label: ${key} , page: ${window.location.pathname}`;
    ErrorUtil.pushErrorToTeliaRumAndLog(error);
    return key;
};
const createNavEvent = (url) => {
    return {
        persist: () => null,
        preventDefault: () => null,
        currentTarget: new URL(url),
    };
};
const NotFoundComponent = (props) => {
    const { teliaWebUrl, defaultTab, disablePlumbrLogging, disableSendingErrorsToMonitoring } = props;
    const monitoringDisabled = disablePlumbrLogging || disableSendingErrorsToMonitoring;
    const [searchFieldValue, setSearchFieldValue] = React.useState('');
    const translate = (key) => {
        var _a;
        if (!!props.translations && !!Object.keys(props.translations).length) {
            return (_a = props.translations[key]) !== null && _a !== void 0 ? _a : handleMissingTranslation(key, monitoringDisabled);
        }
        return key;
    };
    if (document.querySelector('meta[name="robots"]')) {
        document.querySelector('meta[name="robots"]').setAttribute('content', 'none');
    }
    sendErrorToTeliaRum(monitoringDisabled);
    const updateSearchFieldValue = (value) => {
        setSearchFieldValue(value);
    };
    const search = (event) => {
        event.preventDefault();
        if (!searchFieldValue) {
            return;
        }
        const segment = props.segment ? `/${props.segment === 'ari' ? 'ari' : 'era'}` : '';
        const tab = defaultTab ? `&tab=${defaultTab}` : '';
        const url = `${teliaWebUrl}${segment}/otsing?query=${searchFieldValue}${tab}`;
        props.onPathChange ? props.onPathChange(createNavEvent(url)) : window.location.assign(url);
    };
    const renderTopGrid = () => {
        return (React.createElement(Grid, { align: ['start-xs'] },
            React.createElement(GridColumn, { width: ['sm-6', 'lg-5'] },
                React.createElement(Image, { srcset: "https://www.telia.ee/images/pages/etc/404/404-pic-desktop+mob@4x.png", width: 400, align: "center", role: "presentation", shape: "rounded" })),
            React.createElement(GridColumn, { width: ['sm-6', 'lg-5'], align: ['middle-xs'] },
                React.createElement(Text, null,
                    React.createElement(Heading, { level: 1, className: "c-background-7" }, translate('404.new.title')),
                    React.createElement(Heading, { level: 2, className: "h4" }, translate('404.new.text')),
                    props.currentLang === 'en' ? (props.englishContent) : (React.createElement("p", null,
                        translate('404.new.goBack'),
                        React.createElement(Button, { link: true, text: translate('404.new.teliaPage'), isUnderlined: true, url: teliaWebUrl })))))));
    };
    const renderSearchCard = () => {
        return (React.createElement(Card, { padding: "medium", background: "transparent" },
            React.createElement(CardContent, null,
                React.createElement(Text, { className: "text-center" },
                    React.createElement(Heading, { level: 3, className: "h3" }, translate('404.search')),
                    React.createElement(Separator, { color: "invisible", spacing: "small" }),
                    React.createElement(LargeSearch, { id: "notFoundSearchForm", "aria-label": "form", onSubmit: search },
                        React.createElement(TextField, { id: "search", value: searchFieldValue, onChange: updateSearchFieldValue, label: translate('404.search.input') }))))));
    };
    return (React.createElement(Container, null,
        React.createElement(Separator, { spacing: "small", color: "invisible" }),
        renderTopGrid(),
        React.createElement(Separator, { spacing: "large", color: "invisible" }),
        React.createElement(Separator, { spacing: "large", weight: "thin" }),
        renderSearchCard()));
};
export default NotFoundComponent;
